import { ReactElement, ReactNode } from 'react';
import { SContainer, SDot } from './StatusText.style';

type StatusTextProps = {
  color?: string;
  children: ReactNode;
};

export const StatusText = ({ color = '#52C41A', children }: StatusTextProps): ReactElement => (
  <SContainer>
    <SDot
      style={{ background: color }}
    />
    <div>{children}</div>
  </SContainer>
);
